<template>
  <div class="main-container">
      <div class="tools-box">
          <Button @click="backPage" type="primary" ghost>返回</Button>
      </div>
      <Tabs v-model="tabVal">
          <TabPane label="投保信息" name="1"></TabPane>
          <TabPane v-if="productCategory != 2" label="人员清单" name="2"></TabPane>
          <TabPane v-if="productCategory != 2" label="保全信息" name="3"></TabPane>
      </Tabs>

      <holderInfo v-if="tabVal == 1" :id="id"></holderInfo>
      <insureList v-else-if="tabVal == 2 && productCategory != 2" :id="id" :policyNo="policyNo" :orderNo="orderNo"></insureList>
      <peservationInfo v-else-if="tabVal == 3 && productCategory != 2"></peservationInfo>
  </div>
</template>

<script>
var tabVal;
import { common } from '@/api/mixins';
import holderInfo from './components/holderInfo';
import insureList from './components/insureList';
import peservationInfo from './components/peservationInfo';

export default {
  components: {
      holderInfo,
      insureList,
      peservationInfo
  },
  mixins: [common],
  data() {
      return {
          tabVal: '1',
          id: '',
          orderNo: '',
          policyNo: '',
          productCategory: ''
      };
  },
  created() {
      this.id = this.$route.query.id;
      this.policyNo = this.$route.query.policyNo;
      this.orderNo = this.$route.query.orderNo;
      this.productCategory = this.$route.query.productCategory; //1-团险 2-财产险 3、个险
      this.tabVal = tabVal || this.tabVal;
  },
  methods: {
    backPage() {
      this.back('/orderManage/group/order');
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 20px;
  z-index: 1;
}
</style>
